import { Row, Col, Radio, Modal, Form, Input, Divider } from "antd";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                          =   Form.useForm();
  const { request }                     =   useRequest();
  const [loading, setLoading]           =   useState(false);
  const [phoneNumber, setPhoneNumber]   =   useState({ phone: '', country_code: '' });

  const handleChange = (value = '', data = {}) => {
    const country_code = data?.dialCode || '';
    const phone = value ? value.replace(country_code, '') : '';
    setPhoneNumber({ country_code, phone });
  };

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
    setPhoneNumber({
      phone: data?.phone || '',
      country_code: data?.country_code || '',
    });
  }, [data])

  const onCreate = (values) => {
    if (!phoneNumber.phone) return ShowToast('Please enter phone number', Severty.ERROR)
    
      if (((phoneNumber.phone).length < 8 || (phoneNumber.phone).length > 12)) {
      return ShowToast('Phone number should be between 8 to 12 digits', Severty.ERROR);
    }

    const payload = {
      ...values,
      phone : phoneNumber.phone,
      country_code  : phoneNumber.country_code,
    }
    
    setLoading(true);
    request({
      url: `${data ? path + "/" + data._id : path}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    })
  };

  return (
    <Modal
      width={1000}
      open={show}
      title={`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText="Create User"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Name"
              name="name"
              normalize={value => value.trimStart()}
              rules={[
                { required: true, message: "Please Enter the name!" },
                { max: 255, message: "Name should not contain more then 255 characters!" },
                { min: 2, message: "Name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Contact Person Name"
              name="contact_person_name"
              normalize={value => value.trimStart()}
              rules={[
                { max: 255, message: "Contact person name should not contain more then 255 characters!" },
                { min: 2, message: "Contact person name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Contact person Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Please Enter the email address!" },
                { type: 'email', message: 'The email is not a valid email!' },
                { max: 100, message: "Email should not contain more then 100 characters!" },
                { min: 5, message: "Email should contain at least 5 characters!" },
                {
                  pattern: new RegExp(/^([a-zA-Z0-9._%-]*[a-zA-Z]+[a-zA-Z0-9._%-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/),
                  message: "Enter valid email!"
                }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8} className="flagMobileNumber">
            <Form.Item className="mb-0" required={true} 
            label="Phone Number">
              <PhoneInput inputProps={{
                name: "phone",
                required: true,
                autoFocus: false,
                placeholder: "Enter Phone Number"
              }}
                isValid={(value, country) => {
                  if (value.match(/1234/)) {
                    return 'Invalid value: ' + value + ', ' + country.name;
                  } else if (value.match(/1234/)) {
                    return 'Invalid value: ' + value + ', ' + country.name;
                  } else {
                    return true;
                  }
                }}
                country={"in"} value={`${phoneNumber.country_code}${phoneNumber.phone}`} onChange={handleChange} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
};

export default From;